<div class="container-fluid">
  <app-header titleText="{{pageTitle}}"></app-header>

  <mat-tab-group>
    <mat-tab label="Frequently Asked Questions(FAQs)" i18n-label>
      <div class="content">
        <app-faqs></app-faqs>
      </div>
    </mat-tab>
    <mat-tab label="Release Notes" i18n-label>
      <app-release-notes></app-release-notes>      
    </mat-tab>
    <mat-tab label="Release History" i18n-label>
      <div class="content">
        <app-release-history></app-release-history>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
